import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/AncillaryServiceAreas'
import connectIndex from '../../lib/connectIndex'

export class AncillaryServiceAreaIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    records: PropTypes.array,
    pagination: PropTypes.object,
    flashMessages: PropTypes.array.isRequired,
    filterActions: PropTypes.object,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    searchColumns: ['external_id', 'document_id', 'issuer_id']
  }

  // eslint-disable-next-line react/sort-comp
  static showLinkDisplay = (record) => {
    return <Link title={record.external_id} to={`/ancillary_service_areas/${record.id}`}>{record.external_id}</Link>
  }

  // Configure the columns to show as well as whether or not they are filterable or sortable
  static columns = [

    {
      key: 'external_id',
      label: 'External ID',
      display: AncillaryServiceAreaIndex.showLinkDisplay,
      filterable: false,
      sortable: false
    },
    {
      key: 'issuer_id',
      label: 'Issuer',
      filterable: false,
      sortable: false
    },
    {
      key: 'line_of_coverage',
      label: 'Line of Coverage',
      filterable: false,
      sortable: true
    },
    {
      key: 'document',
      label: 'Source Document',
      display: IndexComponent.documentDisplay,
      filterable: false,
      sortable: false
    },
    {
      key: 'audience',
      label: 'Audience',
      filterable: true,
      sortable: false
    },
    {
      key: 'updated_at',
      label: 'Last Updated At',
      display: IndexComponent.dateTimeDisplay,
      filterable: false,
      sortable: true
    },
    {
      key: 'publish_state',
      label: 'Publish Status',
      display: publishStateDisplayWithModal,
      filterable: true,
      recordLabel: 'text',
      recordValue: 'value'
    }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/ancillary_service_areas"
          name="Ancillary Service Area"
          pagination={this.props.pagination}
          columns={AncillaryServiceAreaIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          filterActions={this.props.filterActions}
          searchPlaceholder="Search by External ID, Issuer, or Document ID"
          filterable
          actions={[]}
          searchColumns={this.props.searchColumns}
          newRecordLinkTitle="Import Ancillary Service Area"
          history={this.props.history}
        />
      </div>
    )
  }
}

// Our filterable columns must know the available values on which to filter.
// This is a hard-coded list from the config, but they can also use a remote select
// to search for available options
const filters = [
  {
    key: 'audience',
    config: 'ancillary_service_areas.audience'
  }
]

// wire up our index component with the custom connectIndex that
// links up our filters and actions
export default connectIndex(
  withRouter(AncillaryServiceAreaIndex),
  'ancillaryServiceAreas',
  actions,
  filters
)
